import styled from '@emotion/styled';
import { css } from '@emotion/react';
import COLORS3 from '../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';
import SPACING from '../../styles/emotion/spacing';

export const StyledImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const squareSizes = css`
  height: 220px;
  width: 220px;

  ${MEDIA_QUERY_V2.MOBILE} {
    height: 128px;
    width: 128px;
  }

  ${MEDIA_QUERY_V2.TABLET} {
    height: 160px;
    width: 160px;
  }
`;

const rectangleSizes = css`
  width: 220px;
  height: 310px;

  ${MEDIA_QUERY_V2.MOBILE} {
    width: 128px;
    height: 180px;
  }

  ${MEDIA_QUERY_V2.TABLET} {
    width: 160px;
    height: 225px;
  }
`;

export const ImageElementWrapper = styled.div<{ square: boolean }>`
  object-fit: cover;
  position: relative;
  overflow: hidden;
  ${(props) => (props.square ? squareSizes : rectangleSizes)}
`;

export const StyledCardLink = styled.a<{ square: boolean }>`
  height: 100%;
  width: 220px;
  overflow: hidden;
  border-radius: 16px;
  ${(props) => (props.square ? squareSizes : rectangleSizes)}
`;

export const LinkWrapper = styled.div<{ square: boolean }>`
  margin-bottom: 0;
  transform: none;
  margin-top: ${SPACING.S16};
  text-align: ${({ square }) => (square ? 'left' : 'center')};
  white-space: break-spaces;
`;

export const TileWrapper = styled.div<{
  square?: boolean;
}>`
  display: flex;
  flex-direction: column;
  position: relative;

  ${rectangleSizes};

  ${(props) =>
    props.square &&
    `
    height: 100% !important; // override media query heights

    ${StyledImage} {
      height: 220px;
      width: 220px;
      object-fit: cover;

      ${MEDIA_QUERY_V2.MOBILE} {
        height: 128px;
        width: 128px;
      }

      ${MEDIA_QUERY_V2.TABLET} {
        height: 160px;
        width: 160px;
      }
    }
    `};

  @media (hover: hover) {
    ${StyledImage}, ${ImageElementWrapper} {
      transition: all 0.2s ease-in-out;
    }
    :hover {
      text-decoration: none;
      ${StyledImage}, ${ImageElementWrapper} {
        transform: scale(1.1);
      }
      ${LinkWrapper} {
        text-decoration: underline;
      }
    }
  }
`;

export const ButtonWrapper = styled.div`
  align-self: center;
  max-width: fit-content;
  z-index: 1; // make sure link is above the scrim
  margin-bottom: -68px; // 24px margin, 44px height of the button
  transform: translateY(-68px);

  ${MEDIA_QUERY_V2.TABLET} {
    margin-bottom: -64px; // 20px margin, 44px height of the button
    transform: translateY(-64px);
  }

  ${MEDIA_QUERY_V2.MOBILE} {
    margin-bottom: -60px; // 16px margin, 44px height of the button
    transform: translateY(-60px);
  }

  a {
    background-color: ${COLORS3.CLOUD_100};
  }
`;

export const Scrim = styled.div`
  position: absolute;
  height: 96px;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.16) 100%);
  mix-blend-mode: multiply;
  width: 100%;
  border-radius: 16px;
`;

export const TagWrapper = styled.div`
  position: absolute;
  top: ${SPACING.S8};
  left: ${SPACING.S8};
`;
